import React,{ useState,useEffect } from 'react';
import MenuProductView from './MenuProductView';
import MenuColors from './MenuColors';
import MenuAdjustability from './MenuAdjustability';
import AnimationBtn from './AnimationBtn';
import MenuFeatures from './MenuFeatures';
import Howtousenew from './Howtousenew';
import HowToUse from './HowToUse';
import FooterControl from './FooterControl';
import FooterControlMob from './FooterControlMob';
import Hidden from '@material-ui/core/Hidden';
import Button from '@material-ui/core/Button';
import MenuStand from './MenuStand';


// import MenuBtn from './MenuBtn';
// import { MicNone } from '@material-ui/icons';
var mob = (navigator.userAgent.indexOf("iPhone") != -1) || ((navigator.userAgent.indexOf("Android") != -1) || (navigator.userAgent.indexOf("Mobile") != -1)) || (navigator.userAgent.indexOf('iPod') != -1) || (navigator.userAgent.indexOf('iPad') != -1) || (navigator.userAgent == "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.1 Safari/605.1.15");
var mobPortrait = (mob && window.innerHeight > window.innerWidth);
var moblandscap = (mob && window.innerWidth > window.innerHeight);
var isipad = navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && (navigator.userAgent.indexOf("iPhone") == -1);

export const userContext = React.createContext();
var prevCounter = 0;
var nextClicked = false;
var prevClicked = false;
var buttonSeq = ['onResetMode','onfrontClick','onBackClick','onPortClick','onleftClick','onrightClick','shadingHoodClick','swivelAnimation','heightAnimation','tiltScreenAnimation'];
// var buttonSeq180 = ['onResetMode', 'onFrontClick', 'onTopClick', 'onRightClick', 'onLeftClick', 'openCloseClick', 'backliteClick'];
var selectedButton = 'onResetMode';

var position = {
   'currentPos': 'reset',
   'close': 0,
   'nintyDegree': 1.04167,
   'reset': 2.08333,
   'top': 1.583,
   'tent': 3.125,
   'theatre': 4.1667,
   'tablet': 5.208,
}

const MainMenu = (props) => {
   const [expandedPanel,setExpandedPanel] = useState(false);

   const [frontImg,setfrontImg] = useState("./img/front.png");
   const [portImg,setPortImg] = useState("./img/back_white.png");
   const [leftImg,setLeftImg] = useState("./img/left.png");
   const [rightImg,setRightImg] = useState("./img/right.png");
   const [backImg,setbackImg] = useState("./img/back.png");
   const [monitorPivotImg,setMonitorPivotImg] = useState("./img/pilot_white.png");
   const [monitorSwivelImg,setMonitorSwivelImg] = useState("./img/swivel_white.png");
   const [monitorHeightImg,setMonitorHeightImg] = useState("./img/height_white.png");
   const [monitorSlateImg,setMonitorSlateImg] = useState("./img/front_slant.png");
   const [monitorTiltImg,setMonitorTiltImg] = useState("./img/tilt_white.png");
   const [monitorColorometerImg,setMonitorColorometerImg] = useState("./img/colorometer_white.png");
   const [monitorHoodImg,setMonitorHoodImg] = useState("./img/hood_white.png");

   //   const [orientationPotrait, setOrientation] = useState(true);
   //   window.checkOrientationStatus = (orientationStatus) => 
   //   {
   //   //  alert(window.screen.orientation.type);
   //     setOrientation(orientationStatus);
   //  }

   const handleAccordionChange = (panel) => (event,isExpanded) => {
      //  console.log({ event,isExpanded });
      //setExpandedPanel(isExpanded ? panel  : false );
      if (isExpanded) {
         setExpandedPanel(panel);
         //console.log("shubham");
      } else {
         //  console.log("Pawar");
         setExpandedPanel(false)
      };
      // resetBacklitCloseImg();

   };
   const [camData,setCamData] = useState("");
   var animationSwitch = window.Animation;
   var animTime = 1;
   var animTimes = 1;

   const getData = () => {
      fetch('./model_gl/config.json')
         .then(function (response) {
            return response.json();
         })
         .then(function (myJson) {
            // console.log(myJson.positions);
            setCamData(myJson.positions);
         });
   }
   useEffect(() => {
      getData();
      animationSwitch = window.Animation;
      moblandscap = (mob && window.innerWidth > window.innerHeight);

      window.position = 'reset';

      window.addEventListener('mousedown',() => {

         window.hotspot = '';
      })

      return () => {
         window.removeEventListener('mousedown',() => {
            // document.getElementById('calloutcanvas').style.display = "none";

            window.hotspot = '';
         })

      }
   },[]);

   useEffect((event) => {
      if (event) {
         if (event.keyCode === 13) {
            this.click();
         }
      }

      // alert('Counter in useEffect'+prevCounter);
      // alert('Counter in useEffect'+counter);

   },[])
   useEffect((event) => {
      if (event) {
         if (event.keyCode === 13) {
            this.click();
         }
      }
      //     var isipad = navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && (navigator.userAgent.indexOf("iPhone") == -1);

      // let mob = (navigator.userAgent.indexOf("iPhone") != -1) || ((navigator.userAgent.indexOf("Android") != -1) || (navigator.userAgent.indexOf("Mobile") != -1)) || (navigator.userAgent.indexOf('iPod') != -1) || (navigator.userAgent.indexOf('iPad') != -1) || (navigator.userAgent == "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.1 Safari/605.1.15");

      // alert('Counter in useEffect'+prevCounter);
      // alert('Counter in useEffect'+counter);

   })
   const [animStoped,setanimStoped] = useState(true);

   const animComplete = () => {
      setanimStoped(true);
      var g_navEnabled = true;
      // document.getElementById("onReset").style.pointerEvents = "all";
   }

   //For Animation Switch 
   // console.log('animationSwitch anim', animationSwitch)

   if (animationSwitch == 'on') { animTime = 1000; animTimes = 2000 }
   else { animTime = 1; animTimes = 1 }
   // console.log('animTime', animTime)

   //new camera function
   const GotoPosInTimeNamedValue = (gotoposname,onComplete,onSample) => {
      // below code is updated in it.  
      // updated code ends here

      var opt = undefined,gp = camData[gotoposname];

      //    console.log(gp)
      if (gp.fovy && window.scene.fovy != gp.fovy)
         opt = { fovy: gp.fovy };
      if (gp.pos.length > 5) {
         if (!opt)
            opt = {};
         opt.zang = gp.pos[5];
      }
      // console.log('animationSwitch', animationSwitch)
      if (animationSwitch == 'off') {
         gp.time = 1
         // console.log('animationSwitch iffff', gp.time)
      }
      else {
         gp.time = animTime;
         // console.log('animationSwitch elseeee', gp.time)
      }
      // console.log('animationSwitch',animationSwitch);
      // console.log('gp.time',gp.time);

      if ((isipad || mob) && gotoposname == 'Render_Cam_F02_FL') {
         var temp = gp.pos[1];
         gp.pos[4] = temp + 200;

      }
      if ((isipad || mob) && gotoposname == 'Render_Cam_F02_F') {
         var temp = gp.pos[1];
         gp.pos[4] = temp + 350;

      }
      if ((isipad || mob) && gotoposname == 'Render_Cam_F01_Port') {
         var temp = gp.pos[1];
         gp.pos[4] = temp + 225;

      }
      if ((isipad || mob) && gotoposname == 'Render_Cam_F01_Top') {
         var temp = gp.pos[1];
         gp.pos[4] = temp + 350;

      }
      if ((isipad || mob) && gotoposname == 'Render_Cam_F11_Rear') {
         var temp = gp.pos[1];
         gp.pos[4] = temp + 350;

      }

      window.scene.gotoPosInTime(gp.pos[0],gp.pos[1],gp.pos[2],gp.pos[3],gp.pos[4],gp.time,onComplete,slowInOut,opt);
      // console.log(gp.pos[0], gp.pos[1], gp.pos[2], gp.pos[3], gp.pos[4], gp.time, onComplete, onSample, opt);
   }
   //end
   const slowInOut = (x) => {
      var a = 2.1;
      var x2 = 1.0 - x;
      var px = Math.pow(x,a);
      var px2 = Math.pow(x2,a);

      return px / (px + px2);
   }



   const reversAll = () => {

      window.refport = false;
      window.quickAccess = false;

      // window.playVideo = false;
      // var tex = window.scene._Texture_ref["screen_image.jpg"];
      // var texture = window.scene._Textures[tex.tex_id];
      // console.log(texture)
      // if (texture != null) {
      //    var gl = window.scene.gl;
      //    gl.bindTexture(gl.TEXTURE_2D,texture);
      //    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,true);
      //    gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,
      //       gl.RGBA,gl.UNSIGNED_BYTE,window.staticImage);
      // }

      //  window.hotspot= ' ';
      window.scene._nav._navMinDolly = 28; //50 
      window.scene._nav._navMaxDolly = 66; //110
      window.scene._nav._panMax = [16,30]; //[right, top];
      window.scene._nav._panMin = [-16,-10];    //[left, bottom];
      window.scene.groupApplyState('Stand_button_On');
      window.scene.groupApplyState('SWIVEL_BASE_OFF');
      window.scene.groupApplyState('HEIGHT_ADJUST_OFF');
      window.scene.groupApplyState('TILT_SCREEN_OFF');
      // window.scene.groupApplyState('Reflection_OFF');
      var center = [0,0,0];
      window.scene._nav.SetRotationCenter(center);

      window.scene.clearRefine();

   }
   const reverAnimation = () => {



      if (window.scene.animIsPlaying("Height_Anim")) window.scene.getAnim("Height_Anim").stop();
      if (window.scene.animIsPlaying("TILT_ANIM")) window.scene.getAnim("TILT_ANIM").stop();
      // if (window.scene.animIsPlaying("Pivot_anim")) window.scene.getAnim("Pivot_anim").stop();
      if (window.scene.animIsPlaying("Swivel_anim")) window.scene.getAnim("Swivel_anim").stop();
      if (window.scene.animIsPlaying("SLANT_ANIM")) window.scene.getAnim("SLANT_ANIM").stop();
      // if (window.scene.animIsPlaying("DE_1397_CA__C2423H")) window.scene.getAnim("DE_1397_CA__C2423H").stop();
      if (window.scene.animIsPlaying("SLIDING_PART.001")) window.scene.getAnim("SLIDING_PART.001").stop();
      window.scene.animPlayInTime("SLIDING_PART.001",0,0);
      window.scene.animPlayInTime("Height_Anim",0,0);
      window.scene.animPlayInTime("TILT_ANIM",0,0);
      // window.scene.animPlayInTime("Pivot_Anim",0,0);
      window.scene.animPlayInTime("Swivel_anim",0,0);
      window.scene.animPlayInTime("SLANT_ANIM",0,0);
      // window.scene.animPlayInTime("DE_1397_CA__C2423H",0,0);

      // window.scene.animPlayAllChildrenInTime("Swivel_anim",0.12,0);
      // window.scene._nav.tempfRotMinLimit = 0.001;
      clearTimeout();
      window.scene.clearRefine();
   }
   // const reverAnimation = () => {

   //    // if (window.scene.animIsPlaying("swivel_rotation")) window.scene.getAnim("swivel_rotation").stop();
   //    // if (window.scene.animIsPlaying('hinge_rotate')) window.scene.getAnim("hinge_rotate").stop();
   //    // if (window.scene.animIsPlaying('hing_move')) window.scene.getAnim("hing_move").stop();
   //    // if (window.scene.animIsPlaying('swivel_rotation')) window.scene.getAnim("swivel_rotation").stop();
   //    // if (window.scene.animIsPlaying('hinge_02_Rotate')) window.scene.getAnim("hinge_02_Rotate").stop();
   //    // if (window.scene.animIsPlaying('screen_rotate')) window.scene.getAnim("screen_rotate").stop();
   //    // if (window.scene.animIsPlaying('calibration')) window.scene.getAnim("calibration").stop();
   //    // if (window.scene.animIsPlaying('BOX')) window.scene.getAnim("BOX").stop();

   //    // window.scene.animPlayInTime("hinge_rotate",0,0);
   //    // window.scene.animPlayInTime("hing_move",0,0);
   //    // window.scene.animPlayInTime("swivel_rotation",0,0);
   //    // window.scene.animPlayInTime("hinge_02_Rotate",0,0);
   //    // window.scene.animPlayInTime("screen_rotate",0,0);
   //    // window.scene.animPlayInTime("calibration",0,0);
   //    // window.scene.animPlayInTime("BOX",0,0);

   //    // if (window.scene.animIsPlaying("Height_Anim")) window.scene.getAnim("Height_Anim").stop();
   //    // if (window.scene.animIsPlaying("TILT_ANIM")) window.scene.getAnim("TILT_ANIM").stop();
   //    // if (window.scene.animIsPlaying("Pivot_Anim")) window.scene.getAnim("Pivot_Anim").stop();
   //    // if (window.scene.animIsPlaying("Swivel_anim")) window.scene.getAnim("Swivel_anim").stop();
   //    // if (window.scene.animIsPlaying("DE_1397_CA__C2423H")) window.scene.getAnim("DE_1397_CA__C2423H").stop();

   //    // window.scene.animPlayInTime("Height_Anim",0,0);
   //    // window.scene.animPlayInTime("TILT_ANIM",0,0);
   //    // window.scene.animPlayInTime("Pivot_Anim",0,0);
   //    // window.scene.animPlayInTime("Swivel_anim",0,0);
   //    // window.scene.animPlayInTime("DE_1397_CA__C2423H",0,0);
   //    // window.scene.clearRefine();

   //    if (window.scene.animIsPlaying("Height_Anim")) window.scene.getAnim("Height_Anim").stop();
   //    if (window.scene.animIsPlaying("TILT_ANIM")) window.scene.getAnim("TILT_ANIM").stop();
   //    if (window.scene.animIsPlaying("Pivot_anim")) window.scene.getAnim("Pivot_anim").stop();
   //    if (window.scene.animIsPlaying("Swivel_anim")) window.scene.getAnim("Swivel_anim").stop();
   //    if (window.scene.animIsPlaying("DE_1397_CA__C2423H")) window.scene.getAnim("DE_1397_CA__C2423H").stop();

   //    window.scene.animPlayInTime("Height_Anim",0,0);
   //    window.scene.animPlayInTime("TILT_ANIM",0,0);
   //    window.scene.animPlayInTime("Pivot_Anim",0,0);
   //    window.scene.animPlayInTime("Swivel_anim",0,0);
   //    window.scene.animPlayInTime("DE_1397_CA__C2423H",0,0);
   //    window.scene.clearRefine();



   // } 

   const hideGraphics = () => {
      //window.scene.groupApplyState("100 mm_dimen_off");
      //window.scene.groupApplyState("Tilt_dimen_off");
      // window.scene.groupApplyState("30_dimen_off");

      // window.scene.groupApplyState("45_Degree_off");
      // window.scene.groupApplyState("90_degree_off");
      // window.scene.groupApplyState("21and5_Degree_off");
      window.scene.groupApplyState("mm_130_off");
      window.scene.clearRefine();

   }
   //MenuColorClick

   const color1Click = () => {
      //   var alreadySelecte = document.querySelector('.MuiAccordionDetails-root.select');
      // alreadySelecte.classList.remove('select');

      var alreadySelecte = document.querySelector('.MuiAccordionDetails-root.select');
      if (alreadySelecte != null) {
         alreadySelecte.classList.remove('select');
      }

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      document.getElementById('whiteBtn').classList.add('select');
      document.getElementById('whiteBtn').classList.add('active');



      window.position = 'reset';
      // setOpenCloseOnOff(true);
      // setOpenClose("./img/Lid_close.svg");
      window.scene.groupApplyState("Backlit_OFF");

      // setBackliteOnOff(false);
      // setLaptop360FrontImg("./img/front360.png");
      // setLaptop360TopImg("./img/top360.png");
      // setLaptop360LefttImg("./img/360_left.png");
      // setLaptop360RightImg("./img/360_right.png");
      // setLaptop360BackImg("./img/back_white.png");
      // setLaptop360BackImg("./img/back_white.png");

      window.color = 'laptopSilver';
      window.colorcode = 'laptopSilver';
      // setPort4Click(false);
      window.scene.groupApplyState("Platinum_Silver");


      window.scene.clearRefine();



   }

   const color2Click = () => {

      window.position = 'reset';
      window.color = 'laptopBlack';
      window.closeMode = '';
      window.colorcode = 'laptopBlack';


      // setOpenCloseOnOff(true);
      // setOpenClose("./img/Lid_close.svg");
      // setBackliteOnOff(false);
      // setBacklite("./img/Backlite_Off.svg");
      // setLaptop360FrontImg("./img/front360.png");
      // setLaptop360TopImg("./img/top_black.png");
      // setLaptop360LefttImg("./img/360_left.png");
      // setLaptop360RightImg("./img/360_right.png");
      // setLaptop360BackImg("./img/back_black.png")
      // setLaptop360BackImg("./img/back_black.png");
      // window.scene.groupApplyState("Backlit_OFF");
      // setPort2Click(false);
      // setPort1Click(false);
      // setPort3Click(false);
      // setPort4Click(false);


      window.color = 'Pebble_Green';

      var alreadySelecte = document.querySelector('.MuiAccordionDetails-root.select');
      if (alreadySelecte != null) {
         alreadySelecte.classList.remove('select');
      }

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      document.getElementById('blackBtn').classList.add('select');
      document.getElementById('blackBtn').classList.add('active');
      window.scene.groupApplyState("Pebble_Green");

      window.scene.clearRefine();
   }

   //MenuProductView
   const onfrontClick = (isNextPrevious) => {
      //Update ZoomBar
      window.scene._nav._navMinDolly = 28; //50 
      window.scene._nav._navMaxDolly = 66; //110 
      window.scene._nav._panMax = [16,20]; //[right, top];
      window.scene._nav._panMin = [-16,-10];    //[left, bottom];
      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      document.getElementById('frontBtn').classList.add('active');
      window.hotspot = ' ';

      selectedButton = 'onfrontClick';
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','fronts view');
         document.getElementById('nextView').setAttribute('aria-label','fronts view');
      }
      reversAll();
      reverAnimation();
      window.scene.animPlayInTime("Height_Anim",0.6250000,0,function () {
         animComplete();
      });
      //  window.hotspot= ' ';
      // window.scene.groupApplyState('GP_ON');
      //window.scene.groupApplyState('Ref_ON');
      window.scene.clearRefine();
      window.scene.groupApplyState('Stand_button_On');
      //window.scene.groupApplyState("100 mm_dimen_off");
      //window.scene.groupApplyState("Tilt_dimen_off");
      // window.scene.groupApplyState("30_dimen_off");

      GotoPosInTimeNamedValue('Render_Cam_F02_F',function () {
         window.scene.groupApplyState('Reflection_ON');
         window.scene.groupApplyState('GP_ON');
         if (isNextPrevious != true) {
            window.document.getElementById("hotspot1demo").focus();


         }
         //  window.hotspot= ' colorometer';
         window.hotspot = 'front';

      });

      if (!(window.isipad || window.mob)) {
         document.getElementById("hotspot1").setAttribute("tabindex","-1");
         document.getElementById("hotspot2").setAttribute("tabindex","-1");
         document.getElementById("hotspot3").setAttribute("tabindex","-1");
         document.getElementById("hotspot4").setAttribute("tabindex","-1");
         document.getElementById("hotspot5").setAttribute("tabindex","-1");
         document.getElementById("hotspot6").setAttribute("tabindex","-1");
         document.getElementById("hotspot7").setAttribute("tabindex","-1");
         document.getElementById("hotspot8").setAttribute("tabindex","-1");
         document.getElementById("hotspot9").setAttribute("tabindex","-1");
         document.getElementById("hotspot10").setAttribute("tabindex","-1");

         document.getElementById("hotspot11").setAttribute("tabindex","-1");
         document.getElementById("hotspot12").setAttribute("tabindex","-1");
         document.getElementById("hotspot13").setAttribute("tabindex","1");
         document.getElementById("hotspot14").setAttribute("tabindex","1");
         document.getElementById("hotspot15").setAttribute("tabindex","1");
         // document.getElementById("hotspot16").setAttribute("tabindex","-1");
         // document.getElementById("hotspot17").setAttribute("tabindex","-1");
         // document.getElementById("hotspot18").setAttribute("tabindex","-1");
         // document.getElementById("hotspot19").setAttribute("tabindex","-1");
         // document.getElementById("hotspot20").setAttribute("tabindex","-1");
         // document.getElementById("hotspot21").setAttribute("tabindex","-1");


         document.getElementById("rLeft").setAttribute("tabindex","0");
         document.getElementById("rRight").setAttribute("tabindex","0");
         document.getElementById("zoomOut").setAttribute("tabindex","0");
         document.getElementById("sliderRange").setAttribute("tabindex","0");
         document.getElementById("zoomIn").setAttribute("tabindex","0");
         document.getElementById("previousView").setAttribute("tabindex","0");
         document.getElementById("resetView").setAttribute("tabindex","0");
         document.getElementById("nextView").setAttribute("tabindex","0");

      }
      window.RT_RecordEvent("Product View","fronts",window.config.name);
      window.scene.clearRefine();

   }

   const onPortClick = (isNextPrevious) => {
      //Update ZoomBar
      console.log("top click")
      // window.scene._nav.tempfRotMinLimit = 0.48;

      // window.scene._nav._navMaxDolly = 48; //110 

      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }


      // window.scene._nav.getZoomFactor();

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      document.getElementById('portBtn').classList.add('active');
      window.hotspot = ' ';

      selectedButton = 'onPortClick';
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Ports view');
         document.getElementById('nextView').setAttribute('aria-label','Ports view');
      }
      reversAll();
      reverAnimation();

      // window.refport = true;
      // window.scene._nav._navMinDolly = 12; //50
      // window.scene._nav._panMax = [16,10]; //[right, top];
      // window.scene._nav._panMin = [-16,-7];    //[left, bottom];
      // window.scene._nav.getZoomFactor();
      // window.scene.clearRefine();

      window.scene._nav._navMinDolly = 13.6; //50 
      window.scene._nav._navMaxDolly = 32;
      window.scene._nav._panMax = [16,19]; //[left, bottom];
      window.refport = true;
      // window.scene._nav.tempfRotMinLimit = 0.48;
      window.scene.clearRefine()

      window.scene.groupApplyState('Reflection_OFF');
      window.scene.groupApplyState('GP_OFF');
      GotoPosInTimeNamedValue('Render_Cam_F11_Rear',function () {
         window.scene.groupApplyState('Stand_button_Off');
      });
      setTimeout(() => {
         GotoPosInTimeNamedValue('Render_Cam_F01_Port',function () {
            console.log("shah")
            var center = [0,25.8355,2.3922];
            window.scene._nav.SetRotationCenter(center);
            window.hotspot = 'top';

            animComplete();
         });
      },1300);
      // },1200);
      // },1200);
      if (!(window.isipad || window.mob)) {
         document.getElementById("hotspot1").setAttribute("tabindex","1");
         document.getElementById("hotspot2").setAttribute("tabindex","1");
         document.getElementById("hotspot3").setAttribute("tabindex","1");
         document.getElementById("hotspot4").setAttribute("tabindex","1");
         document.getElementById("hotspot5").setAttribute("tabindex","1");
         document.getElementById("hotspot6").setAttribute("tabindex","1");
         document.getElementById("hotspot7").setAttribute("tabindex","1");
         document.getElementById("hotspot8").setAttribute("tabindex","1");
         document.getElementById("hotspot9").setAttribute("tabindex","1");
         document.getElementById("hotspot10").setAttribute("tabindex","1");

         document.getElementById("hotspot11").setAttribute("tabindex","1");
         document.getElementById("hotspot12").setAttribute("tabindex","1");
         document.getElementById("hotspot13").setAttribute("tabindex","-1");
         document.getElementById("hotspot14").setAttribute("tabindex","-1");
         document.getElementById("hotspot15").setAttribute("tabindex","-1");
         // document.getElementById("hotspot16").setAttribute("tabindex","1");
         // document.getElementById("hotspot17").setAttribute("tabindex","1");
         // document.getElementById("hotspot18").setAttribute("tabindex","1");
         // document.getElementById("hotspot19").setAttribute("tabindex","1");
         // document.getElementById("hotspot20").setAttribute("tabindex","1");
         // document.getElementById("hotspot21").setAttribute("tabindex","1");

         document.getElementById("rLeft").setAttribute("tabindex","0");
         document.getElementById("rRight").setAttribute("tabindex","0");
         document.getElementById("zoomOut").setAttribute("tabindex","0");
         document.getElementById("sliderRange").setAttribute("tabindex","0");
         document.getElementById("zoomIn").setAttribute("tabindex","0");
         document.getElementById("previousView").setAttribute("tabindex","0");
         document.getElementById("resetView").setAttribute("tabindex","0");
         document.getElementById("nextView").setAttribute("tabindex","0");

      }
      window.RT_RecordEvent("Product View","Ports",window.config.name);
      window.scene.clearRefine();

   }

   const onleftClick = (isNextPrevious) => {
      //Update ZoomBar
      window.scene._nav._navMinDolly = 28; //50 
      window.scene._nav._navMaxDolly = 66; //110 
      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      document.getElementById('leftBtn').classList.add('active');
      window.hotspot = ' ';

      selectedButton = 'onleftClick';
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','fronts view');
         document.getElementById('nextView').setAttribute('aria-label','fronts view');
      }
      reversAll();
      reverAnimation();
      window.scene.animPlayInTime("Height_Anim",0.6250000,1,function () {
         animComplete();
      });
      window.hotspot = ' ';

      window.scene.clearRefine();
      window.scene.groupApplyState('Stand_button_On');


      GotoPosInTimeNamedValue('Render_Cam_F02_L',function () {
         window.scene.groupApplyState('Reflection_ON');
         window.scene.groupApplyState('GP_ON');
         //window.scene.groupApplyState('Ref_ON');
         if (isNextPrevious != true) {
            window.document.getElementById("hotspot1demo").focus();
         }
         //    window.hotspot= ' colorometer';

      });

      if (!(window.isipad || window.mob)) {
         document.getElementById("hotspot1").setAttribute("tabindex","1");
         document.getElementById("hotspot2").setAttribute("tabindex","1");
         document.getElementById("hotspot3").setAttribute("tabindex","1");
         document.getElementById("hotspot4").setAttribute("tabindex","1");
         document.getElementById("hotspot5").setAttribute("tabindex","-1");
         document.getElementById("hotspot6").setAttribute("tabindex","-1");
         document.getElementById("hotspot7").setAttribute("tabindex","-1");
         document.getElementById("hotspot8").setAttribute("tabindex","-1");
         document.getElementById("hotspot9").setAttribute("tabindex","-1");
         document.getElementById("hotspot10").setAttribute("tabindex","-1");

         document.getElementById("hotspot11").setAttribute("tabindex","-1");
         document.getElementById("hotspot12").setAttribute("tabindex","-1");
         // document.getElementById("hotspot14").setAttribute("tabindex","-1");

         document.getElementById("rLeft").setAttribute("tabindex","0");
         document.getElementById("rRight").setAttribute("tabindex","0");
         document.getElementById("zoomOut").setAttribute("tabindex","0");
         document.getElementById("sliderRange").setAttribute("tabindex","0");
         document.getElementById("zoomIn").setAttribute("tabindex","0");
         document.getElementById("previousView").setAttribute("tabindex","0");
         document.getElementById("resetView").setAttribute("tabindex","0");
         document.getElementById("nextView").setAttribute("tabindex","0");

      }
      window.RT_RecordEvent("Product View","fronts",window.config.name);
      window.scene.clearRefine();

   }
   const onrightClick = (isNextPrevious) => {
      //Update ZoomBar
      window.scene._nav._navMinDolly = 28; //50 
      window.scene._nav._navMaxDolly = 66; //110 
      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      document.getElementById('rightBtn').classList.add('active');
      window.hotspot = ' ';

      selectedButton = 'onrightClick';
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','fronts view');
         document.getElementById('nextView').setAttribute('aria-label','fronts view');
      }
      reversAll();
      reverAnimation();
      window.scene.animPlayInTime("Height_Anim",0.6250000,1,function () {
         animComplete();
      });
      // window.hotspot = ' ';
      window.scene.clearRefine();


      window.scene.groupApplyState('Stand_button_On');
      GotoPosInTimeNamedValue('Render_Cam_F02_R',function () {
         window.scene.groupApplyState('Reflection_ON');
         window.scene.groupApplyState('GP_ON');
         // window.hotspot = 'right';
         if (isNextPrevious != true) {
            window.document.getElementById("hotspot1demo").focus();
         }


      });

      if (!(window.isipad || window.mob)) {
         document.getElementById("hotspot1").setAttribute("tabindex","1");
         document.getElementById("hotspot2").setAttribute("tabindex","1");
         document.getElementById("hotspot3").setAttribute("tabindex","1");
         document.getElementById("hotspot4").setAttribute("tabindex","1");
         document.getElementById("hotspot5").setAttribute("tabindex","-1");
         document.getElementById("hotspot6").setAttribute("tabindex","-1");
         document.getElementById("hotspot7").setAttribute("tabindex","-1");
         document.getElementById("hotspot8").setAttribute("tabindex","-1");
         document.getElementById("hotspot9").setAttribute("tabindex","-1");
         document.getElementById("hotspot10").setAttribute("tabindex","-1");

         document.getElementById("hotspot11").setAttribute("tabindex","-1");
         document.getElementById("hotspot12").setAttribute("tabindex","-1");
         // document.getElementById("hotspot14").setAttribute("tabindex","-1");

         document.getElementById("rLeft").setAttribute("tabindex","0");
         document.getElementById("rRight").setAttribute("tabindex","0");
         document.getElementById("zoomOut").setAttribute("tabindex","0");
         document.getElementById("sliderRange").setAttribute("tabindex","0");
         document.getElementById("zoomIn").setAttribute("tabindex","0");
         document.getElementById("previousView").setAttribute("tabindex","0");
         document.getElementById("resetView").setAttribute("tabindex","0");
         document.getElementById("nextView").setAttribute("tabindex","0");

      }
      window.RT_RecordEvent("Product View","fronts",window.config.name);
      window.scene.clearRefine();

   }

   const onBackClick = (isNextPrevious) => {
      //Update ZoomBar
      window.scene._nav._navMinDolly = 28; //50 
      window.scene._nav._navMaxDolly = 66; //110 
      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      document.getElementById('backBtn').classList.add('active');
      window.hotspot = ' ';

      selectedButton = 'onBackClick';
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','back view');
         document.getElementById('nextView').setAttribute('aria-label','back view');
      }
      reversAll();
      reverAnimation();
      window.scene.animPlayInTime("Height_Anim",0.6250000,1,function () {
         animComplete();
      });
      window.hotspot = ' ';
      window.scene.clearRefine();


      window.scene.groupApplyState('Stand_button_On');
      GotoPosInTimeNamedValue('Render_Cam_F11_Rear',function () {
         window.scene.groupApplyState('Reflection_ON');
         window.scene.groupApplyState('GP_ON');
         window.hotspot = 'right';
         if (isNextPrevious != true) {
            window.document.getElementById("hotspot1demo").focus();
         }


      });

      if (!(window.isipad || window.mob)) {
         document.getElementById("hotspot1").setAttribute("tabindex","1");
         document.getElementById("hotspot2").setAttribute("tabindex","1");
         document.getElementById("hotspot3").setAttribute("tabindex","1");
         document.getElementById("hotspot4").setAttribute("tabindex","1");
         document.getElementById("hotspot5").setAttribute("tabindex","-1");
         document.getElementById("hotspot6").setAttribute("tabindex","-1");
         document.getElementById("hotspot7").setAttribute("tabindex","-1");
         document.getElementById("hotspot8").setAttribute("tabindex","-1");
         document.getElementById("hotspot9").setAttribute("tabindex","-1");
         document.getElementById("hotspot10").setAttribute("tabindex","-1");

         document.getElementById("hotspot11").setAttribute("tabindex","-1");
         document.getElementById("hotspot12").setAttribute("tabindex","-1");
         // document.getElementById("hotspot14").setAttribute("tabindex","-1");

         document.getElementById("rLeft").setAttribute("tabindex","0");
         document.getElementById("rRight").setAttribute("tabindex","0");
         document.getElementById("zoomOut").setAttribute("tabindex","0");
         document.getElementById("sliderRange").setAttribute("tabindex","0");
         document.getElementById("zoomIn").setAttribute("tabindex","0");
         document.getElementById("previousView").setAttribute("tabindex","0");
         document.getElementById("resetView").setAttribute("tabindex","0");
         document.getElementById("nextView").setAttribute("tabindex","0");

      }
      window.RT_RecordEvent("Product View","fronts",window.config.name);
      window.scene.clearRefine();

   }

   //menuColor

   //MenuFeatureView


   const shadingHoodClick = (isNextPrevious) => {
      console.log('shadingHoodClick')


      //Update ZoomBar
      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }


      selectedButton = 'shadingHoodClick';
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Shading Hood');

         document.getElementById('nextView').setAttribute('aria-label','Shading Hood');
      }

      var fromPos = window.hotspot;
      window.hotspot = ' ';

      window.closeMode = 'on';
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      reversAll();
      reverAnimation();
      hideGraphics();
      // window.playVideo = false;
      // var tex = window.scene._Texture_ref["screen_image.jpg"];
      // var texture = window.scene._Textures[tex.tex_id];
      // console.log(texture)
      // if (texture != null) {
      //    var gl = window.scene.gl;
      //    gl.bindTexture(gl.TEXTURE_2D,texture);
      //    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,true);
      //    gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,
      //       gl.RGBA,gl.UNSIGNED_BYTE,window.staticImage);
      // }
      window.quickAccess = true;
      window.scene._nav._navMinDolly = 25; //50 
      window.scene._nav._navMaxDolly = 66; //110
      window.scene._nav._panMax = [16,25]; //[right, top];
      window.scene._nav._panMin = [-16,-10];    //[left, bottom];
      window.scene.animPlayInTime("Height_Anim",0.6250000,0);
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      document.getElementById('shadingHood').classList.add('active');

      GotoPosInTimeNamedValue('Render_Cam_F02_F',function () {
         window.scene.groupApplyState("Hood_ON");
         window.scene.animPlayInTime("SLIDING_PART.001",0.6250000,1000,function () {
            GotoPosInTimeNamedValue('Render_Cam_F15_Access_Panel',function () {
               window.hotspot = 'hood';

            },3000);
            animComplete();

         });

         if (isNextPrevious != true) {
            window.document.getElementById("hotspot1demo").focus();
         }

      });
      if (!(window.isipad || window.mob)) {

         document.getElementById("hotspot1").setAttribute("tabindex","-1");
         document.getElementById("hotspot2").setAttribute("tabindex","-1");
         document.getElementById("hotspot3").setAttribute("tabindex","-1");
         document.getElementById("hotspot4").setAttribute("tabindex","-1");
         document.getElementById("hotspot5").setAttribute("tabindex","-1");
         document.getElementById("hotspot6").setAttribute("tabindex","-1");
         document.getElementById("hotspot7").setAttribute("tabindex","-1");
         document.getElementById("hotspot8").setAttribute("tabindex","-1");
         document.getElementById("hotspot9").setAttribute("tabindex","-1");
         document.getElementById("hotspot10").setAttribute("tabindex","-1");

         document.getElementById("hotspot11").setAttribute("tabindex","-1");
         document.getElementById("hotspot12").setAttribute("tabindex","-1");
         // document.getElementById("hotspot14").setAttribute("tabindex","1");

         document.getElementById("rLeft").setAttribute("tabindex","0");
         document.getElementById("rRight").setAttribute("tabindex","0");
         document.getElementById("zoomOut").setAttribute("tabindex","0");
         document.getElementById("sliderRange").setAttribute("tabindex","0");
         document.getElementById("zoomIn").setAttribute("tabindex","0");
         document.getElementById("previousView").setAttribute("tabindex","0");
         document.getElementById("resetView").setAttribute("tabindex","0");
         document.getElementById("nextView").setAttribute("tabindex","0");
      }
      window.RT_RecordEvent("Features","Shading Hood",window.config.name);
      window.scene.clearRefine();

   }
   let backliteVar = document.getElementById('backlitBtn');

   const colorometerClick = (isNextPrevious) => {
      // console.log('colorometerClick')
      //Update ZoomBar
      var slider = document.getElementById("sliderRange");
      //
      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label',' Built-in Colorometer');

         document.getElementById('nextView').setAttribute('aria-label',' Built-in Colorometer');
      }
      selectedButton = 'colorometerClick';
      reversAll();
      reverAnimation();
      hideGraphics();

      window.hotspot = ' ';
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }

      document.getElementById('colorometer').classList.add('active');

      window.hotspot = ' reset';
      // var tex = window.scene._Texture_ref["screen_image.jpg"];
      // var texture = window.scene._Textures[tex.tex_id];
      // console.log(texture)
      // if (texture != null) {
      //    var gl = window.scene.gl;
      //    gl.bindTexture(gl.TEXTURE_2D,texture);
      //    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,true);
      //    gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,
      //       gl.RGBA,gl.UNSIGNED_BYTE,window.staticImage);
      // }

      GotoPosInTimeNamedValue('Render_Cam_F02_F',function () {
         if (isNextPrevious != true) {
            window.document.getElementById("hotspot1demo").focus();
         }
         window.scene.animPlayInTime("calibration",2.55,1000,function () {
            window.scene.animPlayInTime("BOX",2.55,1800,function () {
               window.hotspot = ' colorometer';
               window.videoHolder = window.setupVideo('./video/Colorimeter.mp4');
               window.playVideo = true;
               animComplete();
            });
         });

      });
      if (!(window.isipad || window.mob)) {

         document.getElementById("hotspot1").setAttribute("tabindex","-1");
         document.getElementById("hotspot2").setAttribute("tabindex","-1");
         document.getElementById("hotspot3").setAttribute("tabindex","-1");
         document.getElementById("hotspot4").setAttribute("tabindex","-1");
         document.getElementById("hotspot5").setAttribute("tabindex","-1");
         document.getElementById("hotspot6").setAttribute("tabindex","-1");
         document.getElementById("hotspot7").setAttribute("tabindex","-1");
         document.getElementById("hotspot8").setAttribute("tabindex","-1");
         document.getElementById("hotspot9").setAttribute("tabindex","-1");
         document.getElementById("hotspot10").setAttribute("tabindex","-1");

         document.getElementById("hotspot11").setAttribute("tabindex","-1");
         document.getElementById("hotspot12").setAttribute("tabindex","-1");
         // document.getElementById("hotspot14").setAttribute("tabindex","1");

         document.getElementById("rLeft").setAttribute("tabindex","0");
         document.getElementById("rRight").setAttribute("tabindex","0");
         document.getElementById("zoomOut").setAttribute("tabindex","0");
         document.getElementById("sliderRange").setAttribute("tabindex","0");
         document.getElementById("zoomIn").setAttribute("tabindex","0");
         document.getElementById("previousView").setAttribute("tabindex","0");
         document.getElementById("resetView").setAttribute("tabindex","0");
         document.getElementById("nextView").setAttribute("tabindex","0");
      }
      window.RT_RecordEvent("Features","Built-in Colorometer",window.config.name);

      window.scene.clearRefine();
   }




   const swivelAnimation = () => {
      //Update ZoomBar
      // console.log("swivelAnimation");
      //Update ZoomBar
      window.scene._nav._navMinDolly = 28; //50 
      window.scene._nav._navMaxDolly = 66; //110 
      var slider = document.getElementById("sliderRange");
      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      document.getElementById('swivelBtn').classList.add('active');

      selectedButton = 'swivelAnimation';
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Swivel base');
         document.getElementById('nextView').setAttribute('aria-label','Swivel base');
      }
      window.hotspot = ' reset';
      window.hotspot = ' ';
      reversAll();
      reverAnimation();
      hideGraphics();
      window.scene.groupApplyState('base_for_topview');
      //window.scene.groupApplyState('Ref_ON');

      GotoPosInTimeNamedValue('Render_Cam_F01_Top',function () {

         // window.scene._nav._revertPan = true;
         // window.scene._nav._revertPanOriginal = [0.01696,18.191315]; //These are the pan values used on the other cam buttons

         window.scene.groupApplyState('Reflection_ON');
         window.scene.groupApplyState('GP_ON');
         window.scene.groupApplyState('SWIVEL_BASE_ON');

         //window.scene.groupApplyState('Ref_ON');
         // window.scene.groupApplyState('45_Degree_on');
         window.scene.animPlayInTime("Swivel_anim",0.83,3000,function () {
            animComplete();
         });
      })
      window.RT_RecordEvent("Adjustability","Swivel",window.config.name);
      window.scene.clearRefine();
   }

   const heightAnimation = () => {
      //Update ZoomBar
      // console.log("heightAnimation");
      window.scene._nav._navMinDolly = 28; //50 
      window.scene._nav._navMaxDolly = 66; //110 
      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Adjust Height');
         document.getElementById('nextView').setAttribute('aria-label','Adjust Height');
      }

      window.hotspot = ' ';
      reversAll();
      reverAnimation();
      hideGraphics();
      selectedButton = 'heightAnimation';
      window.scene.groupApplyState('Reflection_ON');
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      document.getElementById('heightBtn').classList.add('active');

      window.hotspot = ' reset';
      GotoPosInTimeNamedValue('Render_Cam_F11_Rear',function () {
         // window.scene.groupApplyState('100 mm_dimen_on');
         //window.scene.groupApplyState('Ref_ON');
         window.scene.groupApplyState('Reflection_ON');
         window.scene.groupApplyState('GP_ON');
         window.scene.groupApplyState('HEIGHT_ADJUST_ON');
         // window.scene.groupApplyState('mm_130_on');
         window.scene.animPlayInTime("Height_Anim",0.775,3000,function () {
            animComplete();
         });
      });
      window.RT_RecordEvent("Adjustability","Height",window.config.name);
      window.scene.clearRefine();
   }

   const tiltScreenAnimation = () => {
      //Update ZoomBar
      //  console.log("tiltScreenAnimation");
      window.scene._nav._navMinDolly = 28; //50 
      window.scene._nav._navMaxDolly = 66; //110 
      var slider = document.getElementById("sliderRange");
      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Tilt Screen');
         document.getElementById('nextView').setAttribute('aria-label','Tilt Screen');
      }
      selectedButton = 'tiltScreenAnimation';
      reversAll();
      reverAnimation();
      hideGraphics();
      window.hotspot = ' ';
      window.scene.groupApplyState('Reflection_ON');
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      document.getElementById('tiltScreenBtn').classList.add('active');
      window.hotspot = ' reset';
      //window.scene.groupApplyState('Ref_ON');
      window.scene.animPlayInTime("Height_Anim",0.6250000,0);
      GotoPosInTimeNamedValue('Render_Cam_F02_R',function () {

         // window.scene.groupApplyState('Tilt_dimen_on');
         //window.scene.groupApplyState('Ref_ON');
         window.scene.groupApplyState('Reflection_ON');
         window.scene.groupApplyState('GP_ON');
         window.scene.groupApplyState('TILT_SCREEN_ON');
         // window.scene.groupApplyState('21and5_Degree_on');

         window.scene.animPlayInTime("TILT_ANIM",0.83,3000,function () {
            animComplete();
         });
         window.scene.clearRefine();
      });
      window.RT_RecordEvent("Adjustability","Tilt",window.config.name);
      window.scene.clearRefine();
   }

   const slateScreenAnimation = () => {
      //Update ZoomBar
      //  console.log("tiltScreenAnimation");
      var slider = document.getElementById("sliderRange");
      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Slate Screen');
         document.getElementById('nextView').setAttribute('aria-label','Slate Screen');
      }

      selectedButton = 'slateScreenAnimation';

      reversAll();
      reverAnimation();
      hideGraphics();

      window.hotspot = ' ';

      // window.scene.groupApplyState('Reflection_ON');
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      document.getElementById('slateScreenBtn').classList.add('active');
      window.hotspot = ' reset';
      //window.scene.groupApplyState('Ref_ON');

      GotoPosInTimeNamedValue('Render_Cam_F02_F',function () {

         // window.scene.groupApplyState('slate_dimen_on');
         //window.scene.groupApplyState('Ref_ON');
         window.scene.groupApplyState('Reflection_ON');
         // window.scene.groupApplyState('21and5_Degree_on');
         window.scene.groupApplyState('GP_ON');



         window.scene.animPlayInTime("SLANT_ANIM",0.833,3000,function () {
            animComplete();
         });

         window.scene.animPlayInTime("Height_Anim",0.6250000,0,function () {
            animComplete();
         });

         window.scene.clearRefine();
      });
      window.RT_RecordEvent("Adjustability","Slate",window.config.name);
      window.scene.clearRefine();
   }

   const resetMode = () => {
      selectedButton = 'onResetMode';
      window.scene.animPlayInTime("Height_Anim",0.6250000,3000,function () {
         animComplete();


      });
      //window.scene.groupApplyState('Ref_ON');

      GotoPosInTimeNamedValue('Render_Cam_F02_FL',function () { })
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Reset Mode');
         document.getElementById('nextView').setAttribute('aria-label','Reset Mode');
      }
   }
   const onResetMode = () => {
      //Update ZoomBar
      // console.log(position.tent,position.currentPos)
      document.getElementById('calloutcanvas').style.display = "block";
      var slider = document.getElementById("sliderRange");
      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }
      if (selectedButton == 'onfrontClick') {
         // console.log("front onreset")

         setTimeout(function () {
            window.scene.groupApplyState('Stand_button_On');
            window.scene.groupApplyState('GP_ON');
            GotoPosInTimeNamedValue('Render_Cam_F02_F',function () {
               window.hotspot = 'front';
               // window.document.getElementById("hotspot1demo").focus();

               animComplete();
            });
         })
      }
      else if (selectedButton == 'onPortClick') {
         //   console.log("Port onreset")
         window.scene.groupApplyState('GP_OFF');
         setTimeout(function () {
            GotoPosInTimeNamedValue('Render_Cam_F11_Rear',function () {
               window.scene.groupApplyState('Stand_button_Off');
            });
            setTimeout(() => {
               GotoPosInTimeNamedValue('Render_Cam_F01_Port',function () {
                  // window.scene._nav._revertPan = true;
                  // window.scene._nav._revertPanOriginal = [-0.01696,18.191315];
                  window.hotspot = 'top';
                  window.document.getElementById("hotspot1demo").focus();
                  animComplete();
               });
            },1300);

         })
      }
      else if (selectedButton == 'onleftClick') {
         //    console.log("Port onreset")
         window.scene.groupApplyState('GP_ON');
         setTimeout(function () {
            window.scene.groupApplyState('Stand_button_On');
            GotoPosInTimeNamedValue('Render_Cam_F02_L',function () {
               window.hotspot = ' ';
               window.document.getElementById("hotspot1demo").focus();
               animComplete();
            });
         })
      }
      else if (selectedButton == 'onrightClick') {
         //   console.log("Port onreset")
         window.scene.groupApplyState('GP_ON');
         setTimeout(function () {
            window.scene.groupApplyState('Stand_button_On');
            GotoPosInTimeNamedValue('Render_Cam_F02_R',function () {
               // window.hotspot = 'right';
               window.document.getElementById("hotspot1demo").focus();
               animComplete();
            });
         })
      }
      else if (selectedButton == 'onBackClick') {
         //   console.log("Port onreset")
         window.scene.groupApplyState('GP_ON');
         setTimeout(function () {
            window.scene.groupApplyState('Stand_button_On');
            GotoPosInTimeNamedValue('Render_Cam_F11_Rear',function () {
               // window.hotspot = 'right';
               window.document.getElementById("hotspot1demo").focus();
               animComplete();
            });
         })
      }
      else if (selectedButton == 'shadingHoodClick') {
         shadingHoodClick();
         GotoPosInTimeNamedValue('Render_Cam_F15_Access_Panel',function () {
            window.scene.animPlayInTime("SLIDING_PART.001",0.6250000,400,function () {
               window.hotspot = 'hood';
            });
            window.scene.groupApplyState("Hood_ON");

            window.document.getElementById("hotspot1demo").focus();


            animComplete();
         });

      }
      else if (selectedButton == 'colorometerClick') {
         colorometerClick();

         window.playVideo = true;
         GotoPosInTimeNamedValue('Render_Cam_F02_F',function () {
            window.scene.animPlayInTime("calibration",2.55,1000,function () {
               window.scene.animPlayInTime("BOX",2.55,1800,function () {
                  window.hotspot = '';
                  animComplete();
               });

            })
         })

         // } else if (selectedButton == 'pivotAnimation') {
         //    pivotAnimation();
         //    GotoPosInTimeNamedValue('Render_Cam_F01_Pivot',function () {
         //       // window.scene.groupApplyState('90_degree_on');
         //       window.scene.animPlayAllChildrenInTime("Swivel_anim",0.833,1,function () {
         //          window.scene.animPlayAllChildrenInTime("Swivel_anim",1.66,10000,function () {
         //             animComplete();
         //          });
         //          window.scene.clearRefine();
         //       });

         //    });

      } else if (selectedButton == 'swivelAnimation') {
         swivelAnimation();
         GotoPosInTimeNamedValue('Render_Cam_F01_Top',function () {
            window.scene._nav._revertPan = true;
            window.scene._nav._revertPanOriginal = [-0.01696,18.191315];
            // window.scene.groupApplyState('30_dimen_on');
            // window.scene.groupApplyState('45_Degree_on');
            window.scene.groupApplyState('SWIVEL_BASE_ON');
            window.scene.groupApplyState('GP_ON');
            window.scene.animPlayInTime("Swivel_anim",0.83,5000,function () {
               animComplete();
            });
         })
      } else if (selectedButton == 'heightAnimation') {
         heightAnimation();
         GotoPosInTimeNamedValue('Render_Cam_F11_Rear',function () {
            // window.scene.groupApplyState('100 mm_dimen_on');
            // window.scene.groupApplyState('mm_130_on');
            window.scene.groupApplyState('GP_ON');
            window.scene.groupApplyState('HEIGHT_ADJUST_ON');
            window.scene.animPlayInTime("Height_Anim",0.6250000,2000,function () {
               animComplete();
            });
         });
      } else if (selectedButton == 'tiltScreenAnimation') {
         tiltScreenAnimation();
         GotoPosInTimeNamedValue('Render_Cam_F02_R',function () {
            // window.scene.groupApplyState('Tilt_dimen_on');
            // window.scene.groupApplyState('21and5_Degree_on');
            window.scene.groupApplyState('GP_ON');
            window.scene.groupApplyState('TILT_SCREEN_ON');
            window.scene.animPlayInTime("TILT_ANIM",0.83,2000,function () {
               animComplete();
            });
            window.scene.clearRefine();
         });
      } else if (selectedButton == 'slateScreenAnimation') {
         slateScreenAnimation();
         GotoPosInTimeNamedValue('Render_Cam_F02_F',function () {
            // window.scene.groupApplyState('Tilt_dimen_on');
            // window.scene.groupApplyState('21and5_Degree_on');
            window.scene.groupApplyState('GP_ON');
            window.scene.animPlayInTime("SLANT_ANIM",0.83,2000,function () {
               animComplete();
            });
            window.scene.clearRefine();
         });
      }

      else if (selectedButton == 'onResetMode') {
         resetMode()
         window.scene.groupApplyState('GP_ON');
         GotoPosInTimeNamedValue('Render_Cam_F15_FL',function () { })
      }
      window.scene.clearRefine();
   }

   const onPreviousMode = () => {

      //Update ZoomBar
      document.getElementById('calloutcanvas').style.display = "block";
      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }
      // alert(selectedButton)
      reverAnimation();
      clearTimeout();
      var prevButton;

      var selectedButtonIndex = buttonSeq.findIndex(element => element === selectedButton)
      if (selectedButton == 'onfrontClick' || selectedButton == 'onResetMode') {
         prevButton = 'tiltScreenAnimation';
      } else {
         prevButton = buttonSeq[selectedButtonIndex - 1];
      }
      // }
      // alert(buttonSeq[selectedButtonIndex+1])



      if (prevButton == 'onfrontClick') onfrontClick(true);
      // else if (prevButton == 'onPortClick') onPortClick(true);
      else if (prevButton == 'onPortClick') onPortClick(true);
      else if (prevButton == 'onleftClick') onleftClick(true);
      else if (prevButton == 'onrightClick') {
         setExpandedPanel("panel1");

         onrightClick(true);
      }
      else if (prevButton == 'onBackClick') {
         onBackClick(true);
      }
      else if (prevButton == 'shadingHoodClick') {
         setExpandedPanel("panel3");
         shadingHoodClick(true);
      }

      // else if (prevButton == 'colorometerClick') {
      //    setExpandedPanel("panel3");

      //    colorometerClick(true);
      // }
      // else if (prevButton == 'pivotAnimation') pivotAnimation(true);
      else if (prevButton == 'swivelAnimation') {
         // setExpandedPanel("panel5");
         swivelAnimation(true);
      }
      else if (prevButton == 'heightAnimation') heightAnimation(true);

      else if (prevButton == 'tiltScreenAnimation') {
         setExpandedPanel("panel5");
         tiltScreenAnimation(true);
      }
      // else if (prevButton == 'slateScreenAnimation') {
      //    setExpandedPanel("panel5");
      //    slateScreenAnimation(true);
      // }
      return false;



   }

   const onNextMode = () => {


      //Update ZoomBar
      document.getElementById('calloutcanvas').style.display = "block";
      var slider = document.getElementById("sliderRange");
      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }
      reverAnimation();
      clearTimeout();
      var nextButton;
      var selectedButtonIndex = buttonSeq.findIndex(element => element === selectedButton)
      if (selectedButton == 'tiltScreenAnimation') {
         nextButton = 'onfrontClick';
      } else {
         nextButton = buttonSeq[selectedButtonIndex + 1];
      }
      // }
      // alert(laptop180)


      if (nextButton == 'onfrontClick') {
         setExpandedPanel("panel1");

         onfrontClick(true);
      }
      else if (nextButton == 'onPortClick') onPortClick(true);
      else if (nextButton == 'onleftClick') onleftClick(true);
      else if (nextButton == 'onrightClick') {
         onrightClick(true);
         setExpandedPanel("panel1");
      }
      else if (nextButton == 'onBackClick') {
         onBackClick(true);
         // setExpandedPanel("panel1");
      }

      else if (nextButton == 'shadingHoodClick') {
         setExpandedPanel("panel3");
         shadingHoodClick(true);
      }
      // else if (nextButton == 'colorometerClick') colorometerClick(true);
      // else if (nextButton == 'pivotAnimation') pivotAnimation(true);

      else if (nextButton == 'swivelAnimation') {
         setExpandedPanel("panel5");
         swivelAnimation(true);
      }
      else if (nextButton == 'heightAnimation') heightAnimation(true);
      else if (nextButton == 'tiltScreenAnimation') tiltScreenAnimation(true);
      // else if (nextButton == 'slateScreenAnimation')

      //    slateScreenAnimation(true);


      return false;


   }

   const [animValue,setAnimValue] = useState("On");
   const [animValue1,setAnimValue1] = useState("On");

   useEffect(() => {
      // alert();
      document.getElementById("animSwitchValue").setAttribute('aria-label','Animation On')
      // document.getElementById('animSwitchValue').setAttribute('aria-label','clickable checkbox checked On');
      document.getElementById("animSwitchValue").checked = true;

      setAnimValue("On");
      window.Animation = 'on';
      document.getElementsByClassName('onOff')[0].style.left = "-17px";
      window.animationSwitchVal = 'on';



      document.getElementById("animSwitchValue1").setAttribute('aria-label','Animation On')
      // document.getElementById('animSwitchValue1').setAttribute('aria-label','clickable checkbox checked On');
      document.getElementById("animSwitchValue1").checked = true;

      setAnimValue("On");
      window.Animation = 'on';
      document.getElementsByClassName('onOff1')[0].style.left = "-17px";

   },[]);

   const setAnimationSwitch = (e) => {
      //  console.log(e)
      // displayName(e);
      const isChecked = document.getElementById("animSwitchValue").checked;

      if (isChecked == true) {
         document.getElementById("animSwitchValue").setAttribute('aria-label','Animation Off');
         document.getElementById("animSwitchValue").checked = false;
         setAnimValue("Off");
         document.getElementsByClassName('onOff')[0].style.left = "9px";

         window.Animation = 'off';
         window.animationSwitchVal = 'off';

         window.RT_RecordEvent("Animations","Off",window.config.name);
         //   document.getElementById('animSwitchValue').setAttribute('aria-label', '');
         // document.getElementById('animSwitchValue').innerHTML = 'clickable checkbox checked On';
         // alert("Animation On");

      } else {
         document.getElementById("animSwitchValue").setAttribute('aria-label','Animation On')
         document.getElementById("animSwitchValue").checked = true;
         window.animationSwitchVal = 'on';
         setAnimValue("On");
         window.Animation = 'on';
         document.getElementsByClassName('onOff')[0].style.left = "-17px";

         window.RT_RecordEvent("Animations","On",window.config.name);
         // alert("Animation Off");
         //   document.getElementById('animSwitchValue').setAttribute('aria-label', '');
         // document.getElementById('animSwitchValue').innerHTML = 'clickable checkbox checked Off';
      }
   }

   const displayName = (e) => {
      //   console.log(e)
      const isChecked = document.getElementById("animSwitchValue").checked;

      if (isChecked == true) {
         setAnimValue("On");
         window.Animation = 'on';
         document.getElementsByClassName('onOff')[0].style.left = "-17px";
         document.getElementById('animSwitchValue').setAttribute('aria-label','');
         document.getElementById('animSwitchValue').innerHTML = 'clickable checkbox checked On';
         window.animationSwitchVal = 'off';
         // document.getElementById('animSwitchValue').setAttribute('aria-label','clickable checkbox checked On');
         // alert("Animation On");

      } else {
         setAnimValue("Off");
         document.getElementsByClassName('onOff')[0].style.left = "9px";
         window.Animation = 'off';
         document.getElementById('animSwitchValue').setAttribute('aria-label','');
         document.getElementById('animSwitchValue').innerHTML = 'clickable checkbox checked Off';
         window.animationSwitchVal = 'on';
         // document.getElementById('animSwitchValue').setAttribute('aria-label','clickable checkbox checked Off');
         // alert("Animation Off");

      }

   }

   const keyboardOff = () => {
      //   console.log('Keyboard off');
      document.onkeydown = function (e) {
         if (e.keyCode == 13 || e.keyCode == 32)
            setExpandedPanel(false)
         e.preventDefault();
         return false;
      };
   }
   const keyboardOn = () => {
      //  console.log('Keyboard on');
      document.onkeydown = function (e) {
         return true;
      }
   }


   const setAnimationSwitch1 = (e) => {
      //  console.log(e)
      // displayName(e);
      const isChecked = document.getElementById("animSwitchValue1").checked;

      if (isChecked == true) {
         //document.getElementById("animSwitchValue").setAttribute('aria-label', 'Animation Off');
         document.getElementById("animSwitchValue1").checked = false;
         setAnimValue1("Off");
         // keyboardOff();
         document.getElementsByClassName('onOff1')[0].style.left = "9px";
         window.animationSwitchVal = 'off';
         window.animationSwitchGlobal = 'off';


      } else {
         // document.getElementById("animSwitchValue").setAttribute('aria-label', 'Animation On')
         document.getElementById("animSwitchValue1").checked = true;

         setAnimValue1("On");
         window.animationSwitchVal = 'on';
         // keyboardOn();
         window.animationSwitchGlobal = 'on';
         document.getElementsByClassName('onOff1')[0].style.left = "-17px";




      }
   }
   var animStopped = true;

   const displayName1 = (e) => {
      if (animStopped == false) {
         return;
         animStopped = false;
      }
      //  console.log(e)
      const isChecked = document.getElementById("animSwitchValue1").checked;

      if (isChecked == true) {
         setAnimValue1("On");
         // keyboardOn();
         window.animation1SwitchGlobal = 'on';
         document.getElementsByClassName('onOff1')[0].style.left = "-17px";
         document.getElementById('animSwitchValue1').setAttribute('aria-label','clickable checkbox checked On');
         window.animationSwitchVal = 'on';

         if (mob) {
            document.getElementById('footerControls').removeAttribute('style');
            document.getElementById('footerControMob').style.display = 'block';
         }
         else if (isipad) {
            //   console.log('portrait');
            document.getElementById('footerControMob').style.display = 'block';
            document.getElementById('footerControls').style.display = 'block';
         }
         else {
            //   console.log("show");

            document.getElementById('footerControls').style.transition = "bottom 0.2s linear";
            document.getElementById('footerControls').style.bottom = "20px";
            document.getElementById('footerControMob').style.transition = "bottom 0.2s linear";
            document.getElementById('footerControMob').style.bottom = "20px";
            //  document.getElementById('footerControIpad').style.transition = "bottom 0.2s linear";
            //  document.getElementById('footerControIpad').style.bottom = "20px";

            document.getElementById('footerControls').style.visibility = "";
            document.getElementById('footerControIpad').style.visibility = "";
            document.getElementById('footerControMob').style.visibility = "";

         }


      } else {
         setAnimValue1("Off");
         // keyboardOff();
         document.getElementsByClassName('onOff1')[0].style.left = "9px";
         window.animation1SwitchGlobal = 'off';

         document.getElementById('animSwitchValue1').setAttribute('aria-label','clickable checkbox checked Off');

         if (mob) {
            document.getElementById('footerControls').removeAttribute('style');
            document.getElementById('footerControMob').style.display = 'none';
         } else if (isipad) {
            //   console.log('landscape');
            document.getElementById('footerControMob').style.display = 'none';
            document.getElementById('footerControls').style.display = 'none';
         }
         else {
            //   console.log("hide");
            //document.getElementById('footerControls').style.transition = "bottom 0.2s linear";
            document.getElementById('footerControls').style.bottom = "-112px";
            //   document.getElementById('footerControMob').style.transition = "bottom 0.24s linear";
            document.getElementById('footerControMob').style.bottom = "-112px";
            //  document.getElementById('footerControIpad').style.bottom = "-112px"; 

            setTimeout(function () {

               document.getElementById('footerControls').style.visibility = "hidden";
               document.getElementById('footerControIpad').style.visibility = "hidden";

               document.getElementById('footerControMob').style.visibility = "hidden";

               animStopped = true;
            },150);
         }

      }

   }

   return (
      <>
         {/* <Hidden only={["xs",'sm']}> */}
         {!mob && <HowToUse />}
         {/* </Hidden> */}
         <Hidden only={['sm','md','lg','xl']}>

            <Button style={{ position: 'fixed',backgroundColor: '#F0F0F0',width: '100%',height: '56px',paddingTop: '15px',paddingBottom: '15px',zIndex: '1',border: '1px solid #E1E1E1',borderLeft: "none",borderRight: "none",borderRadius: "0",margin: "-1px 0px 0px 0px" }}
               variant="outlined"
               color="primary"
               // className={classes.button}
               endIcon={<img src="./img/cross.svg" alt="cross" style={{ marginLeft: '207px',height: '23px' }} />}
               onClick={props.toggleDrawerAction}
            >
               {window.finalLangues.mainmenu}
            </Button>
            <Howtousenew />

         </Hidden>
         <Hidden only={['md','lg','xl','xs']}>
            {moblandscap && <Howtousenew />}
         </Hidden>

         <Hidden only={["xs"]}>
            <FooterControl name="reset and next previous" onReset={onResetMode} onPrevious={onPreviousMode} onNext={onNextMode} />
         </Hidden>
         <Hidden only={['lg','xl']}>
            <FooterControlMob onResetMob={onResetMode} onPreviousMob={onPreviousMode} onNextMob={onNextMode} onResetIpad={onResetMode} onNextIpad={onNextMode} onPreviousIpad={onPreviousMode} />
         </Hidden>
         {/* <MenuSelectProductType tabIndex="1" name="Select Product Type" onclicked={laptopClick} onclickedtwo={select2in1Click} value={value} expanded={expandedPanel === 'panel5'} onChanged={handleAccordionChange('panel5')}/> */}
         {/* <userContext.Provider value=""> } */}
         {/* <MenuColors id="menuColor" tabIndex="1" name="Colors" onWhiteBtnClick={color1Click} onBlackBtnClick={color2Click} expanded={expandedPanel === 'panel4'} onChanged={handleAccordionChange('panel4')} /> */}
         {/* { </userContext.Provider> */}
         {/* <MenuStand name="Stand" tabIndex="1" expanded={expandedPanel === 'panel2'} onChanged={handleAccordionChange('panel2')} /> */}

         <MenuProductView name={window.finalLangues.productView} tabIndex="1" onfrontBtnClick={onfrontClick}
            onPortBtnClick={onPortClick} onLeftBtnClick={onleftClick} onRightBtnClick={onrightClick} onBackBtnClick={onBackClick} imgfront={frontImg} imgport={portImg} imgleft={leftImg} imgright={rightImg} imgback={backImg} expanded={expandedPanel === 'panel1'} onChanged={handleAccordionChange('panel1')} />

         <MenuFeatures name="Features" tabIndex="1" onShadingHoodClicked={shadingHoodClick} onColorometerClicked={colorometerClick} imgcolorometer={monitorColorometerImg} imghood={monitorHoodImg} expanded={expandedPanel === 'panel3'} onChanged={handleAccordionChange('panel3')} />

         <MenuAdjustability name={window.finalLangues.adjustability} tabIndex="1"
            // pivotAnim={pivotAnimation} 
            swivelAnim={swivelAnimation} heightAnim={heightAnimation}
            tiltScreenAnim={tiltScreenAnimation} slateScreenAnim={slateScreenAnimation} imgpivot={monitorPivotImg} imgswivel={monitorSwivelImg} imgheight={monitorHeightImg} imgslate={monitorSlateImg} imgtilt={monitorTiltImg} expanded={expandedPanel === 'panel5'} onChanged={handleAccordionChange('panel5')} />

         <AnimationBtn onchange={displayName} forKeypress={setAnimationSwitch} value={animValue} onchange1={displayName1} forKeypress1={setAnimationSwitch1} value1={animValue1} />

      </>
   );
}

export default MainMenu;